import type { StoreTreeNodeType } from '@dh-software/furnhome-types';

export interface StateType {
  environment: string;
  page: string;
  content: string;
  language: string;
  // Die an der Login-Maske gewaehlte Sprache. Getrennt von `language`, das die aktive
  // UI-Sprache fuehrt: diese hier ist nur eine der Quellen, aus denen sie bestimmt wird.
  loginLanguage: string;
  loggedIn: boolean;
  customerNo: string;
  userName: string;
  contactId: string;
  allowedModules: Array<string>;
  storeTree: Array<StoreTreeNodeType>;
  // Die letzte Sub-Route je Modul, ohne den Modulnamen (`price/42`). Ein Rail-Klick oeffnet das
  // Modul wieder dort. Beim Abmelden geleert.
  moduleRoutes: Readonly<Record<string, string>>;
}

export function createInitialState(): StateType {
  return {
    environment: '',
    page: 'loading',
    content: 'home',
    language: '',
    loginLanguage: '',
    loggedIn: false,
    customerNo: '',
    userName: '',
    contactId: '',
    allowedModules: [],
    storeTree: [],
    moduleRoutes: {},
  };
}
